import { btoaHex } from '@iotv/iotv-v3-types';
import { PayloadDataGridCell } from '../../../factories/DataGrid';
import { dateTimeNow } from '../../../NetworkSystem/cellFormatters/valueFormatters';
export const dlQueueColumns = [
    {
        field: 'id',
        headerName: 'Message ID',
        width: 300,
    },
    {
        field: 'timestamp',
        headerName: 'Time',
        width: 200,
        valueFormatter: dateTimeNow,
    },
    {
        field: 'deviceDlCnt',
        headerName: 'Downlink Count',
        width: 130,
        sortable: false,
    },
    {
        field: 'payload',
        headerName: 'Payload',
        minWidth: 120,
        maxWidth: 1000,
        flex: 1,
        sortable: false,
        renderCell: (p) => PayloadDataGridCell(p),
    },
    {
        field: 'payload64',
        headerName: 'Base64',
        minWidth: 120,
        maxWidth: 1000,
        flex: 1,
        sortable: false,
        valueGetter: (val, row) => (row.payload ? btoaHex(row.payload) : ''),
    },
];
export const dlHistoryColumns = [
    {
        field: 'timestamp',
        headerName: 'Time',
        width: 200,
        valueFormatter: dateTimeNow,
    },
    {
        field: 'status',
        headerName: 'Status',
        minWidth: 150,
        flex: 2,
        sortable: false,
    },
    {
        field: 'deviceDlCnt',
        headerName: 'Downlink Count',
        width: 130,
    },
    {
        field: 'sentPayloadStr',
        headerName: 'Payload',
        minWidth: 120,
        maxWidth: 1000,
        flex: 1,
        sortable: false,
        renderCell: (p) => PayloadDataGridCell(p),
    },
    {
        field: 'sentPayload64',
        headerName: 'Base64',
        minWidth: 120,
        maxWidth: 1000,
        flex: 1,
        sortable: false,
        valueGetter: (val, row) => (row.sentPayloadStr ? btoaHex(row.sentPayloadStr) : ''),
    },
];
